import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { ClearButton } from '../../../../components/button/ClearButton';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { toLongDateTime } from '../../../../utils/date-utils';
import { MailJobStatusMetadata } from '../../models/enums/mailjob-status';
import { MailJobRead } from '../../models/mailjobs/mailjob-read';

// #region Component Props

interface IProps {
    mailjob         : MailJobRead;
    downloadAction  : any;
    markDoneAction  : any|undefined;
}

// #endregion

const MailJobRow = (props: IProps) => (
    <tr>
        <td>{ toLongDateTime(props.mailjob.createdOn) }</td>
        <td>{ props.mailjob.documentCount }</td>
        <td>{ props.mailjob.pageCount }</td>
        <td>{ MailJobStatusMetadata[props.mailjob.status].display }</td>
        <td className="action-cell-icons">
            <ClearButton
                id={'invoicerow-' + props.mailjob.id }
                text="Download"
                classes="action"
                onBtnClick={ () => props.downloadAction(props.mailjob.id) }
                icon="la-file-pdf-o" />
            {
                props.markDoneAction ?
                <HasPermission requiredPermissions={[
                    Permissions.CommunicationsMailTriageMarkDone
                ]}>
                    <ClearButton
                        id={'invoicerow-' + props.mailjob.id }
                        text="Mark Done"
                        classes="action"
                        onBtnClick={ () => props.markDoneAction(props.mailjob.id) }
                        icon="la-check-circle" />
                </HasPermission> : null
            }
        </td>                              
    </tr>
);

export { MailJobRow };
